import Link from "next/link";
import { useRouter } from "next/router";
import { MAX_WIDTH, NARROW_WIDTH } from "./constants";

function Demobar({
  narrow = false,
  noMargin,
  copy,
}: {
  narrow?: boolean;
  noMargin?: boolean;
  copy?: string;
}) {
  const { locale } = useRouter();
  return (
    <section
      style={{
        margin: noMargin ? 0 : `${narrow ? 0 : 24}px auto 24px`,
      }}
    >
      <h2>
        {copy ? (
          copy
        ) : (
          <>
            Ready to build a high-impact climate{" "}
            {locale === "en-GB" ? "programme" : "program"}?
          </>
        )}
      </h2>
      <Link href="/demo" passHref>
        <a className="button primary" data-track-id="demobar.contact">
          Request a demo
        </a>
      </Link>
      <style jsx>{`
        section {
          width: 100%;
          max-width: ${narrow ? NARROW_WIDTH : MAX_WIDTH}px;
          padding: 8px 24px;
          border-radius: 16px;
          background-color: #e0f0ff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
        }
        @media (min-width: 820px) {
          section {
            padding: 32px 48px;
          }
        }
        h2 {
          font-size: 24px;
          color: #294aae;
          flex-grow: 1;
          margin: 16px 32px 16px 0;
          z-index: 0;
        }
        .button {
          display: inline-block;
          font-size: 18px;
          margin-top: 16px;
          margin-bottom: 16px;
        }
      `}</style>
    </section>
  );
}

export default Demobar;
